@if (segments().length > 0) {
  <div class="session-progress">
    @for (segment of segments(); track $index) {
      <span
        class="session-progress__segment"
        [class.session-progress__segment--active]="segment.active"
        [class.session-progress__segment--current]="segment.current"></span>
    }
  </div>
}
